package navigation.root.splash

import androidx.compose.runtime.Composable
import cafe.adriel.voyager.core.screen.Screen
import ui.splash.SplashScreen

object SplashScreenNav : Screen {
    @Composable
    override fun Content() {
        SplashScreen()
    }
}
